<template>
	<v-form ref="formEditUser">
		<h2>User Details</h2>

		<v-row>
			<v-col>
				<v-text-field
					v-model="localUser.username"
					label="Username"
					readonly
					disabled
				/>
			</v-col>
			<v-col>
				<v-text-field
					v-model="localUser.firstname"
					label="First Name"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-text-field
					v-model="localUser.lastname"
					label="Last Name"
				/>
			</v-col>
			<v-col>
				<v-text-field
					v-model="localUser.email"
					label="Email"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-select
					v-model="localUser.preferred_locale"
					:items="localeOptions"
					label="Preferred Language"
					clearable
					hint="Used to select the product name language in reports. Defaults to the shop's default store if not set."
					persistent-hint
				/>
			</v-col>
		</v-row>

		<v-btn
			class="mr-4 mb-4"
			@click="save"
		>
			Save
		</v-btn>
	</v-form>
</template>

<script>
/* global config */
import axios from 'axios'

export default {
	name: 'UserDetailsForm',
	props: {
		selectedUser: { type: Object, required: true },
	},
	data() {
		return {
			localUser: {},
			localeOptions: [
				{ text: 'German', value: 'de' },
				{ text: 'English', value: 'en' },
				{ text: 'French', value: 'fr' },
				{ text: 'Italian', value: 'it' },
			],
		}
	},
	watch: {
		selectedUser: {
			immediate: true,
			handler(value) {
				this.localUser = { ...value }
			},
		},
	},
	methods: {
		async save() {
			try {
				await axios.put(`${config.baseAPIurl}/user-manager/user-details`, { user: this.localUser })
				this.$emit('saved')
			} catch (error) {
				this.$emit('error', error)
			}
		},
	},
}
</script>
